import axios from 'axios';
import API_URL from '../constant'

export function requestGetAgents(data) {
    return axios.request({
      method: 'get',
      url: API_URL + `agents?populate=*&[pagination][page]=1${data ? `&[pagination][pageSize]=${data}` : ''}`
    });
  }
  